import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({ selector: '[scrollParent]' })
export class ScrollParentDirective {
    @Input('scrollParent') direction:string;
    @HostListener('click') onClick() {
        var element = this.el.nativeElement.parentElement;
        
        if (this.direction === "right") {
            var pixelsOffRight = element.scrollWidth - element.clientWidth - element.scrollLeft;
            scrollToX(element, element.scrollLeft + Math.min(pixelsOffRight, element.clientWidth / 2));
        } else {
            var pixelsOffLeft = element.scrollLeft;
            scrollToX(element, element.scrollLeft - (Math.min(pixelsOffLeft, element.clientWidth / 2)));
        }
    }
    constructor(private el: ElementRef) { }
}

// first add raf shim
// http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
var requestAnimFrame = (function(){
    return  window.requestAnimationFrame       ||
            window['webkitRequestAnimationFrame'] ||
            window['mozRequestAnimationFrame']    ||
            function( callback ){
              window.setTimeout(callback, 1000 / 60);
            };
  })();
  
  var scrollToX = (element:HTMLElement, scrollTargetX:number, speed?:number, easing?:string) => {
      // scrollTargetY: the target scrollY property of the window
      // speed: time in pixels per second
      // easing: easing equation to use
  
      var scrollLeft = element.scrollLeft,
          scrollTargetX = scrollTargetX || 0,
          speed = speed || 1000,
          easing = easing || 'easeOutSine',
          currentTime = 0
  
      // min time .1, max time .8 seconds
      var time = Math.max(.1, Math.min(Math.abs(scrollLeft - scrollTargetX) / speed, .8));
  
      // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
      var easingEquations = {
              easeOutSine: function (pos) {
                  return Math.sin(pos * (Math.PI / 2));
              },
              easeInOutSine: function (pos) {
                  return (-0.5 * (Math.cos(Math.PI * pos) - 1));
              },
              easeInOutQuint: function (pos) {
                  if ((pos /= 0.5) < 1) {
                      return 0.5 * Math.pow(pos, 5);
                  }
                  return 0.5 * (Math.pow((pos - 2), 5) + 2);
              }
          };
  
      // add animation loop
      function tick() {
          currentTime += 1 / 60;
  
          var p = currentTime / time;
          var t = easingEquations[easing](p);
  
          if (p < 1) {
              requestAnimFrame(tick);
  
              element.scrollLeft = scrollLeft + ((scrollTargetX - scrollLeft) * t);
          } else {
              element.scrollLeft = scrollTargetX;
          }
      }
  
      // call it once to get started
      tick();
  }
  


// WEBPACK FOOTER //
// ./web/static/services/directives/ScrollParent.ts